/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPLOADIMAGE= createAsyncThunk(
  "uploadImage/uploadImage",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const uploadImageSlice = createSlice({
  name: "uploadImageSlice",
  initialState: {
    uploadImage: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfuploadImage: (state) => {
        state.uploadImage.loading = false
        state.uploadImage.error = false
        state.uploadImage.data = []
        state.uploadImage.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPLOADIMAGE.fulfilled, (state, action) => {
      state.uploadImage = {
        ...state.uploadImage,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPLOADIMAGE.pending, (state, action) => {
      state.uploadImage = {
        ...state.uploadImage,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPLOADIMAGE.rejected, (state, action) => {
      state.uploadImage = {
        ...state.uploadImage,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const uploadImageAction = {
    UPLOADIMAGE,
};

export { uploadImageAction };
export default uploadImageSlice.reducer;
export const {setInitialStateOfuploadImage} = uploadImageSlice.actions